module.exports = __webpack_public_path__ + "img/list-launcher.b33a7c19.png";